import cn from 'classnames';
import { MouseEvent, ReactElement, useMemo } from 'react';
import { Icon } from '../Icon';
import type { ModalProps } from './Modal.types';

import s from './Modal.module.css';

const Modal = ({
  open,
  children,
  width,
  onlyVertical,
  hasCloseButton = true,
  onClose,
}: ModalProps): ReactElement | null => {
  const widthCalc = useMemo(() => {
    if (typeof width === 'number') {
      return `${width}px`;
    }

    if (width === 'string') return width;

    return undefined;
  }, [width]);

  const handleClick = (eve: MouseEvent<HTMLDivElement>) => {
    eve.stopPropagation();
  };

  if (!open) return null;

  return (
    <section data-testid="modal" className={s.overlay} onClick={onClose} aria-hidden role="dialog">
      <div
        className={cn(
          s.modal,
          { [s.noCloseButton]: !hasCloseButton },
          { [s.onlyVertical]: onlyVertical },
        )}
        style={{ maxWidth: widthCalc }}
        onClick={handleClick}
        aria-hidden
      >
        {hasCloseButton && (
          <button className={s.buttonClose} onClick={onClose}>
            <Icon variant="solid" name="Close" color="neutral-900" />
          </button>
        )}
        {children}
      </div>
    </section>
  );
};

export default Modal;
